module.exports = __webpack_public_path__ + "img/Wayne.08f7ab71.png";